import { modelName } from './constants';
export const getData = (state) => state[modelName].data;
export const getFailed = (state) => state[modelName].error;
